import { useState, useEffect, useRef } from 'react';
import CustomButtonGroup from '../../../../../common/components/customized/custombuttongroup/CustomButtonGroup';
import AddIcon from '@mui/icons-material/Add';
import { Box, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import constants from '../../../../../utils/constants';
import './Logistics.scss';
import AddLogistics from './AddLogistics';
import CustomDataGrid from '../../../../../common/components/customized/customdatagrid/CustomDataGrid';
import CustomIconButton from '../../../../../common/components/buttons/CustomIconButton';
import { Icon } from '@iconify/react';
import CustomDeletePopup from '../../../../../common/components/customdelete/CustomDeletePopup';
import CustomActivatePopup from '../../../../../common/components/customactive/CustomActivatePopup';
import CustomSelect from '../../../../../common/components/customized/customselect/CustomSelect';
import { useForm } from 'react-hook-form';
import { useAppSelector, useAppDispatch } from '../../../../../app/redux/hooks';
import {
  deactiveLogistics,
  deleteLogistics,
  getLogistics
} from '../../../redux/reducer/truckManagementSlices/logisticSlice';
import { GridCellProps } from '@mui/x-data-grid';
import Actions from '../../../../../common/pages/user/management/components/reports/Actions';
import CustomDialog from '../../../../../common/components/customdialog/CustomDialog';
import { updateIsShowMap } from '../../../../../features/yaantrac/redux/reducer/yaantracSlices/reportSlice';
import CustomSearch from '../../../../../common/components/customized/customsearch/CustomSearch';
import { useAbort, usePagination } from '../../../../../utils/commonFunctions';

export interface PaginationModel {
  page: number;
  pageSize: number;
}

const Logistics = () => {
  const [role, setRole] = useState<string>('');
  const [newValue, setnewValue] = useState<any>('');
  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [isActivate, setIsActivate] = useState<boolean>(false);
  const [filteredRow, setFilteredRow] = useState<any>();
  const [tripRows, setTripRows] = useState([]);
  const [label, setLabel] = useState('');

  const [sortModel, setSortModel] = useState<any>([]);
  const [inputValue, setInputValue] = useState<any>('');
  const [index, setIndex] = useState(0);
  const { pageSize, pageNo, pagination, setPageNo, setPageSize } = usePagination();
  const [tablePayload, setTablePayload] = useState({
    pageNo: 1,
    pageSize: 5,
    sortColumnName: null,
    sortBy: null,
    searchInput: null,
    searchColumnName: null,
    roleType: ''
  });
  const intervalId = useRef<NodeJS.Timeout | null>(null);

  const { data: rows, isLoading, type, count } = useAppSelector(state => state.Logistics);
  const { isShowMap, Polyline, Waypoints } = useAppSelector(state => state.reportDialog);
  const dispatch = useAppDispatch();
  const createAbort = useAbort();

  const { control, setValue } = useForm();

  const isOpen = Boolean(anchorEl);

  const placeholderText = [
    'Search for Stakeholder ID',
    'Search for Load Number',
    'Search for First Name',
    'Search for Last Name',
    'Search for Contact Number',
    'Search for Email'
  ];

  const dynamicOptions = [
    {
      id: `${inputValue}`,
      label: `Account ID :${inputValue}`,
      columnName: 'stakeholderId'
    },
    {
      id: `${inputValue}`,
      label: `Company Name :${inputValue}`,
      columnName: 'companyName'
    },
    {
      id: `${inputValue}`,
      label: `First Name :${inputValue}`,
      columnName: 'firstName'
    },
    {
      id: `${inputValue}`,
      label: `Last Name :${inputValue}`,
      columnName: 'lastName'
    },
    {
      id: `${inputValue}`,
      label: `Mobile NO :${inputValue}`,
      columnName: 'contactNumber'
    },
    {
      id: `${inputValue}`,
      label: `Email :${inputValue}`,
      columnName: 'email'
    }
  ];

  const options = [
    {
      label: 'Add Customer',
      value: 'Customer',
      icon: <AddIcon fontSize='small' sx={{ color: '#3239EA' }} />
    },
    {
      label: 'Add Shipper',
      value: 'Shipper',
      icon: <AddIcon fontSize='small' sx={{ color: '#3239EA' }} />
    },
    {
      label: 'Add Consignee',
      value: 'Consignee',
      icon: <AddIcon fontSize='small' sx={{ color: '#3239EA' }} />
    }
  ];

  let columns = [
    {
      field: 'isActive',
      headerName: `Status`,
      flex: 1,
      minWidth: 100,
      renderCell: ({ value }: GridCellProps) =>
        value === 1 ? (
          <Icon icon='carbon:circle-filled' style={{ color: '#0EBC93' }} />
        ) : (
          <Icon icon='carbon:circle-filled' style={{ color: '#FF2532' }} />
        )
    },
    {
      field: 'stakeholderId',
      headerName: `Account ID`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'company',
      headerName: `Company Name`,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => (
        <Tooltip color='primary' placement='bottom' title={params?.row?.company} arrow>
          {params?.row?.company}
        </Tooltip>
      )
    },
    {
      field: 'roleType',
      headerName: `Role`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'firstName',
      headerName: `First Name`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'lastName',
      headerName: `Last Name`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'contactNumber',
      headerName: `Mobile No.`,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'email',
      headerName: `Email ID`,
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => (
        <Tooltip color='primary' placement='bottom' title={params?.row?.email} arrow>
          {params?.row?.email}
        </Tooltip>
      )
    },
    {
      field: 'address',
      headerName: `Address`,
      flex: 1,
      sortable: false,
      minWidth: 150,
      renderCell: (params: any) => Actions(params)
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => (
        <Box>
          <Tooltip title='Menu' placement='right' arrow>
            <IconButton
              id='basic-button'
              sx={{ display: 'flex', justifyContent: 'flex-start', pl: 0 }}
              aria-controls={isOpen ? 'basic-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={isOpen ? 'true' : undefined}
              onClick={event => {
                setRole(row?.roleType);
                setLabel(`Update ${row?.roleType}`);
                handleUpdate(row);
                setFilteredRow(row);
                setAnchorEl(event.currentTarget);
              }}
            >
              <Icon icon='eva:menu-2-outline' className='white-bg' />
            </IconButton>
          </Tooltip>
          <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
            <MenuItem
              disabled={filteredRow?.isActive === 0}
              onClick={() => {
                setIsUpdate(true);
                setOpen(true);
                handleClose();
              }}
            >
              <CustomIconButton category='Update' showTooltip={false} /> {''}
              {constants.Update}
            </MenuItem>
            <MenuItem
              onClick={() => {
                setIsActivate(true);
                handleClose();
              }}
            >
              {filteredRow?.isActive === 0 ? (
                <CustomIconButton showTooltip={false} category='Active' />
              ) : (
                <CustomIconButton showTooltip={false} category='Deactive' />
              )}

              {filteredRow?.isActive === 0 ? constants.ActiveStatus : constants.Deactive}
            </MenuItem>
            <MenuItem
              disabled={filteredRow?.isActive === 0}
              onClick={() => {
                setIsDelete(true);
                // deleteLogistics(row);
                setMessage(`${constants.DeleteCustomer} ${role}?`);
                handleClose();
              }}
            >
              <CustomIconButton category='Delete' showTooltip={false} /> {''}
              {constants.Delete}
            </MenuItem>
          </Menu>
        </Box>
      )
    }
  ];

  let dropdownOptions = [
    {
      id: 'All',
      label: 'All'
    },
    {
      id: 'Customer',
      label: 'Customer'
    },
    {
      id: 'Shipper',
      label: 'Shipper'
    },
    {
      id: 'Consignee',
      label: 'Consignee'
    }
  ];

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Function to stop the interval
  const stopInterval = () => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
      intervalId.current = null;
    }
  };

  // handle start interval
  const startInterval = () => {
    intervalId.current = setInterval(() => {
      setIndex(prevIndex => {
        return prevIndex === placeholderText.length - 1 ? 0 : prevIndex + 1;
      });
      if (inputValue.length > 0) {
        stopInterval();
      }
    }, 2000);
  };

  // function for dynamic options
  const handleInputChange = async (event: any, newValue: string) => {
    const payload: any = {
      ...tablePayload,
      searchInput: newValue
    };
    if (!newValue) {
      await dispatch(
        getLogistics({ ...payload, signal: createAbort().abortCall.signal })
      );
    }
    setTablePayload(payload);
    setInputValue(newValue);
    setPageNo(1);
    setPageSize(5);
  };

  // function for filter Search
  const handleSearchColumnChange = async (event: any, newValue: any) => {
    const payload = {
      ...tablePayload,
      searchColumnName: newValue?.columnName,
      searchInput: newValue?.id
    };
    setTablePayload(payload);
    await dispatch(getLogistics({ ...payload, signal: createAbort().abortCall.signal }));
    setPageNo(1);
    setPageSize(5);
  };

  // function for normal search

  const handleSearch = async () => {
    const payload = {
      ...tablePayload,
      searchInput: inputValue
    };
    setTablePayload(payload);
    await dispatch(getLogistics({ ...payload, signal: createAbort().abortCall.signal }));
    setPageNo(1);
    setPageSize(5);
  };

  const handlePagination = async (newPaginationModel: PaginationModel) => {
    await dispatch(
      getLogistics({
        ...pagination(newPaginationModel),
        signal: createAbort().abortCall.signal
      })
    );
  };

  const handleSortModelChange = async (model: any) => {
    setSortModel(model);
    const payload = {
      ...tablePayload,
      pageNo: pageNo,
      pageSize: pageSize,
      sortColumnName: (model.length > 0 && model[0].field) || null,
      sortBy: (model.length > 0 && model[0].sort.toUpperCase()) || null
    };
    setTablePayload(payload);
    await dispatch(getLogistics({ ...payload, signal: createAbort().abortCall.signal }));
  };

  const handleUpdate = (params: any) => {
    setFilteredRow(params);
  };

  const handleSelect = (value: string) => {
    setFilteredRow(null);
    setLabel(`Add ${value}`);
    setRole(value);
    setOpen(true);
  };

  const handleDelete = async () => {
    if (filteredRow?.id) {
      let action1 = await dispatch(
        deleteLogistics({ id: filteredRow?.id, roleType: filteredRow?.roleType })
      );
      if (deleteLogistics.fulfilled.match(action1)) {
        setPageNo(1);
        setPageSize(5);
        await dispatch(
          getLogistics({
            ...tablePayload,
            roleType: newValue,
            signal: createAbort().abortCall.signal
          })
        );
      }
    }
    setIsDelete(false);
  };

  const handleDeactivate = async () => {
    if (filteredRow?.id) {
      const action1 = await dispatch(
        deactiveLogistics({ id: filteredRow?.id, roleType: filteredRow?.roleType })
      );
      if (deactiveLogistics.fulfilled.match(action1)) {
        setPageNo(1);
        setPageSize(5);
        await dispatch(
          getLogistics({
            ...tablePayload,
            roleType: newValue,
            signal: createAbort().abortCall.signal
          })
        );
      }
    }
    setIsActivate(false);
  };

  useEffect(() => {
    if (rows?.length > 0) {
      setTripRows(rows);
    } else {
      setTripRows([]);
    }
  }, [rows]);

  useEffect(() => {
    dispatch(
      getLogistics({
        ...tablePayload,
        roleType: '',
        signal: createAbort().abortCall.signal
      })
    );
    setValue('vehicle', 'All');
    return () => {
      createAbort().abortCall.abort();
    };
  }, []);

  // useEffect(() => {
  //   if (inputValue.length > 0) {
  //     stopInterval();
  //   }
  //   if (inputValue.length < 1) {
  //     startInterval();
  //   }
  // }, [inputValue]);

  return (
    <>
      <Box className='logistics' sx={{ position: 'relative', overflow: 'hidden' }}>
        <Box className='logistics-title '>
          <CustomButtonGroup options={options} label={'Add'} handleClick={handleSelect} />
        </Box>

        <Box sx={{ position: 'absolute', zIndex: '1' }}>
          <CustomSelect
            id='select-vehicle'
            options={dropdownOptions}
            control={control}
            name='vehicle'
            placeholder='Select Role'
            className='reports-select'
            onChanges={(e: any, newValue: any) => {
              setnewValue(newValue?.id);
              if (newValue?.id === 'All') {
                setValue('vehicle', newValue?.id);
                let payload = {
                  pageNo: 1,
                  pageSize: 5,
                  sortColumnName: null,
                  sortBy: null,
                  searchInput: null,
                  searchColumnName: null,
                  roleType: ''
                };
                setTablePayload(payload);

                dispatch(
                  getLogistics({ ...payload, signal: createAbort().abortCall.signal })
                );
              } else if (newValue && newValue !== 'All') {
                setValue('vehicle', newValue?.id);

                let payload = {
                  pageNo: 1,
                  pageSize: 5,
                  sortColumnName: null,
                  sortBy: null,
                  searchInput: null,
                  searchColumnName: null,
                  roleType: newValue?.id
                };
                setTablePayload(payload);
                dispatch(
                  getLogistics({ ...payload, signal: createAbort().abortCall.signal })
                );
              }
            }}
          />
        </Box>

        <Box
          sx={{
            // position: 'absolute',

            // bottom: '80px',
            // top: '-4px',
            // zIndex: 1,
            // right: '100px',
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}
          className='search-text'
        >
          <CustomSearch
            id='searchField'
            control={control}
            name='searchField'
            options={dynamicOptions}
            // placeholder={placeholderText[index]}
            placeholder='Search for ...'
            icon={<i className='custom-icon' />}
            variant='standard'
            inputValue={inputValue}
            handleInputChange={handleInputChange}
            onChanges={handleSearchColumnChange}
            handleSearchClick={handleSearch}
          />
        </Box>

        <CustomDataGrid
          rows={tripRows ? tripRows : []}
          columns={columns}
          loading={type === 'logistics' && isLoading}
          onSortModelChange={handleSortModelChange}
          rowCount={count}
          sortingMode='server'
          type={'logistics'}
          pageNo={pageNo}
          pageSize={pageSize}
          paginationModel={{
            page: pageNo && count ? pageNo - 1 : 0,
            pageSize: pageSize ? pageSize : 5
          }}
          onPaginationModelChange={handlePagination}
        />
      </Box>
      {open && (
        <AddLogistics
          open={open}
          setPageNo={setPageNo}
          setPageSize={setPageSize}
          setOpen={setOpen}
          newValue={newValue}
          label={label}
          roleType={role}
          filteredRow={filteredRow}
          isLoading={isLoading}
        />
      )}
      {isDelete && (
        <CustomDeletePopup
          open={isDelete}
          handleDelete={handleDelete}
          setOpen={setIsDelete}
          handleClose={handleClose}
          message={message}
          isLoading={type === 'delete' && isLoading}
        />
      )}
      {isActivate && (
        <CustomActivatePopup
          filteredRow={filteredRow}
          open={isActivate}
          setOpen={setIsActivate}
          handleDeactivate={handleDeactivate}
          isLoading={type === 'deactivate' && isLoading}
        />
      )}

      {isShowMap && (
        <CustomDialog
          view={isShowMap}
          tripsData={Polyline}
          locations={Waypoints}
          isShowMap={isShowMap}
          handleViewClose={() => {
            dispatch(updateIsShowMap(false));
          }}
          maplegend={false}
        />
      )}
    </>
  );
};

export default Logistics;
